<template>
  <div class="validation_request_order_offer_agency" :class="{ 'detailed-view': isDetails }">
    <div class="validation_request_order_offer_agency_head">
      <div class="head">
        <h4>Agence {{agency.attributes.display_name}}</h4>
      </div>
      <p class="validation_request_order_offer_agency_organisation">
        <em>Organisation: {{agency.included.organization.attributes.display_name}}</em>
      </p>
    </div>

    <div class="validation_request_order_offer_agency_container" >
      <div>
          <h5>Adresse</h5>
          <ul>
            <li>{{agency.attributes.street_line1}}</li>
            <li v-if="agency.attributes.street_line2">{{agency.attributes.street_line2}}</li>
            <li>{{agency.attributes.zipcode}} {{agency.attributes.city}}</li>
            <li>
              {{getUsStateTranslatedValue(agency.attributes.state)}} 
              {{getCountryTranslatedValue(agency.attributes.country)}}
            </li>
          </ul>

          <h5>Contact</h5>
          <ul>
            <li>Tél. : {{agency.attributes.phone}}</li>
            <li>Permanence téléphonique : {{agency.attributes.final_hotline_phone}}</li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ValidationRequestableOrderOfferAgencyV2",
  props: ["agency", "isDetails"]
}
</script>

<style scoped>
.validation_request_order_offer_agency_head {
  text-align: center;
  border-bottom: solid 1px lightgray;
  padding-left: 15px;
  padding-right: 15px;

}

.validation_request_order_offer_agency_container{
  display: flex;
  padding-right: 15px;
  padding-left: 15px;

}

.validation_request_order_offer_agency {
  background-color: white;
  width: 20%;
}

.head {
  width: 100%;
}

.head h4 {
  display: inline-block;
}

.head button {
  display: inline-block;
}

.detailed-view {
  border-right:solid 1px lightgrey;
}

@media screen and (max-width: 800px) {
  .validation_request_order_offer_agency_head {
    text-align: center;
    border:0;
    border-top:solid 1px lightgray;
    border-bottom: solid 1px lightgray;
    margin-top: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .validation_request_order_offer_agency_container{
    display: flex;
    border: 0;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .validation_request_order_offer_agency {
    width: 100%;
    border-top:0;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Offer/AgencyV2.vue